import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { Switch } from 'antd'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'

import { isRtv } from '../../../util/profiles'
import { getMessage } from '../../../util/IntlMessages'

const Header = ({
  getWalletCustomers,
  customersCount,
  exportCSV,
  exportExcelData,
  history,
  globalFilterValue,
  onGlobalFilterChange
}) => {
  const currentUser = useSelector((state) => state.auth.auth)
  const [isMyWallet, setIsMyWallet] = useState(false)

  return (
    <Toolbar
      start={
        <React.Fragment>
          <div>
            <h2>
              <b>Lista de Agricultores</b>
            </h2>
            {currentUser && isRtv(currentUser) && (
              <>
                <p>
                  {getMessage('myCustomers')}
                  <Switch
                    style={{ marginLeft: 10 }}
                    checked={isMyWallet}
                    onChange={(value) => {
                      if (value) {
                        const currentUserDistricts = currentUser.districts.map(({ id }) => id)
                        getWalletCustomers({ districtId: currentUserDistricts })
                      } else {
                        getWalletCustomers()
                      }
                      setIsMyWallet(value)
                    }}
                    className="mr-2"
                  />
                </p>
                {isMyWallet && <p>{customersCount} Eleitos</p>}
              </>
            )}
          </div>
        </React.Fragment>
      }
      end={
        <React.Fragment>
          <div style={{ display: 'flex' }}>
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search"> </InputIcon>
              <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Pesquisar" />
            </IconField>
            <Button
              style={{ marginLeft: '10px' }}
              type="button"
              className="p-button-success mr-2"
              icon="pi pi-file"
              rounded
              onClick={() => exportCSV(false)}
              data-pr-tooltip="CSV"
            />
            <Button
              type="button"
              className="p-button-success mr-2"
              icon="pi pi-file-excel"
              severity="success"
              rounded
              onClick={exportExcelData}
              data-pr-tooltip="XLS"
            />
            <Button icon="pi pi-plus" onClick={() => history.push(`/customer/create`)} />
          </div>
        </React.Fragment>
      }
    />
  )
}

export default Header
